import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class ErrorMixin extends Vue {
  public setError(err: any) {
    this.clearNotif();
    let errMess;
    console.log(typeof err);
    console.log(err);
    if (err.message) {
      errMess = err.message;
    } else {
      let shortErr = err.toString().substring(7);
      shortErr = JSON.parse(shortErr).message;
      errMess = JSON.parse(shortErr);
    }
    Vue.notify({
      group: "notif",
      title: this.$t("error").toString(),
      type: "error",
      text: errMess,
      duration: -5000,
    });
  }

  public setErrorFromTxt(err: string, title?: string) {
    this.clearNotif();
    Vue.notify({
      group: "notif",
      type: "error",
      title: title ? title : this.$t("Error").toString(),
      text: err,
      duration: -5000,
    });
  }

  public setSuccess(message: string) {
    this.clearNotif();
    Vue.notify({
      group: "notif",
      type: "sucess",
      title: message,
      duration: 5000,
    });
  }

  public setErrorsFromTxt(err: string, title?: string) {
    Vue.notify({
      group: "notif",
      type: "error",
      title: title ? title : this.$t("Error").toString(),
      text: err,
      duration: -5000,
    });
  }

  public clearNotif() {
    this.$notify({
      group: "notif",
      clean: true,
    });
  }
}
